module.exports = __webpack_public_path__ + "static/img/8.7fb6b45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/8.png
// module id = 1IUB
// module chunks = 0